import { Analytics } from '@analytics';
import EmojiAvatar from '@components/EmojiAvatar';
import { Button, MenuItem, Tooltip, Modal, FormControl, InputLabel, Select, Input, Checkbox, ListItemText, Chip, Avatar, ListItemAvatar, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import { regionalURLs } from '@utils/constants';
import { useIsFeatureForCompanyEnabled } from '@utils/hooks';
import React from 'react';
import { useIntl } from 'react-intl';
import ButtonWithMenu from '../../Common/ButtonWithMenu';
import AccessControlledButton from '../AccessControlledButton';
import messages from './messages';
import axios from 'axios'
import { remove } from 'lodash';

const useStyles = makeStyles({
  menuItemText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    fontWeight: 600,
    color: '#000',
    minWidth: 'fit-content'
  },
  viewButton: {
    color: '#000',
    position: 'absolute',
    bottom: 5,
    right: 5
  }
});

// Tailwind class strings reused across the card and modals
const paperClasses =
  'absolute w-full max-w-[600px] bg-white rounded-3xl shadow-xl border border-solid border-slate-200 p-8 pb-4 text-slate-600 overflow-y-auto max-h-[80vh] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2';
const iconClasses = 'w-[51px] min-w-[51px] h-[51px] rounded-full mr-4';

const ResourceListItem = ({ resource, deleteResource, editResource, downloadQRCode, fetchResources, assignedUserIds }) => {
  const intl = useIntl();
  const classes = useStyles();
  const isFeatureForCompanyEnabled = useIsFeatureForCompanyEnabled();

  let linkUrl =
    (regionalURLs[process.env.REGION] || regionalURLs.US) + `t/c/${resource.assignedCardIds[0]}`;
  if (process.env.NODE_ENV == 'development') {
    linkUrl = 'http://localhost:3002/' + `t/c/${resource.assignedCardIds[0]}`;
  }

  ///ANDY START
  const [open, setOpen] = React.useState(false);
  const [previewOpen, setPreviewOpen] = React.useState(false);
  const [error, setError] = React.useState(null);

  const handleOpen = () => {
    setError(null);
    setOpen(true);
  };

  const handleClose = () => {
    setError(null);
    setOpen(false);
  };

  const handlePreviewOpen = () => {
    setPreviewOpen(true);
  };

  const handlePreviewClose = () => {
    setPreviewOpen(false);
  };

  React.useEffect(() => {
    if (resource?.teamUsers?.length) {
      setSelectedUserIds(resource.teamUsers.map((u) => u._id));
    }
  }, [resource]);

  const handleSave = async () => {
    const groupId = resource.groupId; // You must pass this with the resource or resolve it somehow
    const previousIds = (resource.teamUsers || []).map((u) => u._id?.toString());
    const currentIds = selectedUserIds;

    const added = currentIds.filter((id) => !previousIds.includes(id));
    const removed = previousIds.filter((id) => !currentIds.includes(id));
    console.log('logging save', previousIds, currentIds, added, removed)

    try {
      setError(null);
      // Add users
      for (const userId of added) {
        await axios.post('/api/v1/tipdirect/groups/add', {
          groupId,
          type: 'user',
          id: userId,
        });
      }

      // Remove users
      for (const userId of removed) {
        await axios.post(`/api/v1/tipdirect/groups/remove/${groupId}/user/${userId}`);
      }

      // Optional: show success, refresh data, close modal
      console.log('Team updated successfully!');
      setOpen(false);

      if (typeof fetchResources === 'function') {
        await fetchResources(); // ✅ refresh latest resource state
      }

    } catch (err) {
      console.error('Error saving team updates:', err);
      const errMsg = err.response?.data?.error?.message || err.response?.data?.error || err.message;
      setError(errMsg);
    }
  };


  const handleChange = (event) => {
    const newSelection = event.target.value;
    setSelectedUserIds(newSelection);
  };

  const handleDelete = (idToDelete) => {
    setSelectedUserIds((prev) => prev.filter((id) => id !== idToDelete));
  };
  const allUserOptions = [...resource.teamUsers, ...resource.availableUsers];

  const teamUserOptions = resource.teamUsers || [];
  const getUserLabel = (user) => {
    if (user.nickname) {
      return [user?.firstName, user?.lastName, ' (' + user?.nickname + ')'].filter(Boolean).join(' ').trim()
    }
    if (user.firstName) {
      return [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim()
    }
    return user?.profile?.nickname?.trim() ||
      [user?.profile?.firstName, user?.profile?.lastName].filter(Boolean).join(' ').trim() ||
      user?.email ||
      'Unknown User';
  }


  const [selectedUserIds, setSelectedUserIds] = React.useState([]);



  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const menuHeight = Math.min((resource.teamUsers?.length || 0) + (resource.availableUsers?.length || 0), 10) * ITEM_HEIGHT;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: menuHeight + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    },
    getContentAnchorEl: null
  };
  console.log('allUserOptions', allUserOptions)
  const modalBody = (
    <div className={paperClasses}>
      <div className="flex justify-center items-center mb-4">
        <div className={iconClasses}>
          <EmojiAvatar code={resource.emoji || ':credit_card:'} />
        </div>
      </div>

      <h2 className="text-3xl font-bold text-slate-800 tracking-tight text-center leading-snug">{resource.name}'s Team</h2>

      <div className="text-lg font-medium text-slate-500 text-center mt-1">Add or remove people to this team below:</div>
      <p id="simple-modal-description">
        <FormControl className="w-full mt-4">
          <Autocomplete
            multiple
            options={allUserOptions}
            value={allUserOptions.filter((user) => selectedUserIds.includes(user._id))}
            filterOptions={(options, state) => {
              const filtered = options.filter((option) =>
                getUserLabel(option).toLowerCase().includes(state.inputValue.toLowerCase())
              );
              return allUserOptions.length > 40 ? filtered.slice(0, 40) : filtered;
            }}
            onChange={(event, newValue) => {
              handleChange({
                target: { value: newValue.map((user) => user._id) }
              });
            }}
            disableCloseOnSelect
            getOptionLabel={(option) => getUserLabel(option)}
            getOptionDisabled={(option) => assignedUserIds?.has(option._id) && !(resource.teamUsers?.some(u => u._id === option._id))}
            renderOption={(option, { selected }) => {
              const isAssignedElsewhere = assignedUserIds?.has(option._id) && !(resource.teamUsers?.some(u => u._id === option._id));
              // Use fallback avatar if avatarUrl is null/undefined
              const avatarUrl = option.avatarUrl || option.profile?.avatarUrl || null;
              return (
                <>
                  <Checkbox
                    style={{ marginRight: 8 }}
                    checked={selected}
                    disabled={isAssignedElsewhere}
                  />
                  <ListItemAvatar>
                    <Avatar src={avatarUrl}>
                      {!avatarUrl && getUserLabel(option).charAt(0)}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={getUserLabel(option)}
                    secondary={isAssignedElsewhere ? 'Already in another team' : ''}
                  />
                </>
              );
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => {
                // Safely access avatarUrl and profile.avatarUrl
                const avatarUrl = (option && (option.avatarUrl || (option.profile && option.profile.avatarUrl))) || null;
                return (
                  <Chip
                    label={getUserLabel(option)}
                    avatar={
                      avatarUrl ? (
                        <Avatar src={avatarUrl} />
                      ) : (
                        <Avatar>{getUserLabel(option).charAt(0)}</Avatar>
                      )
                    }
                    {...getTagProps({ index })}
                  />
                );
              })
            }
            filterSelectedOptions
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Team Members"
                placeholder="Type to filter team members"
              />
            )}
          />
        </FormControl>
      </p>
      {error && (
        <p className="text-red-600 mt-4 text-sm text-center font-medium">
          {error}
        </p>
      )}
      <p id="simple-modal-description" className="flex justify-end mt-6">
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          className="!bg-indigo-600 hover:!bg-indigo-700 !text-white !font-semibold !px-5 !py-2.5 !rounded-xl !shadow-sm !normal-case">
          Save
        </Button>
      </p>
    </div>
  );
  console.log('resource', resource)


  const getMenuBody = () => {
    return [
      <MenuItem
        key={`view-${resource._id}`}
        disabled={resource.assignedCardsAmount === 0}
        className={classes.menuItemText}
        onClick={() => {
          window.open(linkUrl, '_blank');
          Analytics.track('View resource clicked');
        }}>
        View
      </MenuItem>,
      <MenuItem
        key={`qrcode-${resource._id}`}
        disabled={resource.assignedCardsAmount === 0}
        className={classes.menuItemText}
        onClick={() => {
          downloadQRCode(linkUrl, resource.name);
          Analytics.track('Download QR code clicked');
        }}>
        {intl.formatMessage(messages.downloadQRCode)}
      </MenuItem>,
      <AccessControlledButton
        key={`edit-${resource._id}`}
        feature={'ResourceTippingPoints'}
        as="MenuItem"
        elementStyle={classes.menuItemText}
        title={'Edit Resource'}
        onClick={() => {
          editResource(resource);
          Analytics.track('edit resource opened');
        }}
      />,
      <MenuItem
        key={`disband-${resource._id}`}
        className={classes.menuItemText}
        disabled={!isFeatureForCompanyEnabled('ResourceTippingPoints')}
        onClick={handleOpen}>
        Edit Team
      </MenuItem>,
      <MenuItem
        key={`delete-${resource._id}`}
        className={classes.menuItemText}
        disabled={!isFeatureForCompanyEnabled('ResourceTippingPoints')}
        onClick={() => {
          deleteResource(resource);
          Analytics.track('delete resource opened');
        }}>
        {intl.formatMessage(messages.deleteResource)}
      </MenuItem>
    ];
  };

  return (
    <>
      <div className="w-full h-[147px] mb-4 flex flex-col p-4 rounded-3xl bg-white shadow-sm border border-solid border-slate-200 relative md:max-w-[350px] lg:max-w-[400px]">
        <div className="flex flex-row justify-between mb-2">
          <div className={iconClasses}>
            <EmojiAvatar code={resource.emoji || ':credit_card:'} />
          </div>
          <div className="flex flex-row justify-start h-10 items-center -mr-[7px]">
            <div
              className={[
                'flex items-center justify-center whitespace-nowrap min-w-[108px] px-3 py-0.5 rounded-full text-[11px] font-bold border border-solid mr-2.5',
                (!resource.teamUsers?.length || resource.groupStatus === 'closed')
                  ? 'bg-slate-100 text-slate-500 border-slate-200/55'
                  : 'bg-emerald-50 text-emerald-700 border-emerald-200/55',
              ].join(' ')}
            >
              {`${intl.formatMessage(messages.status)}: ${!resource.teamUsers?.length || resource.groupStatus === 'closed'
                ? intl.formatMessage(messages.isNotInTeam)
                : intl.formatMessage(messages.activeTeam)
                }`}
            </div>
            <div className="flex justify-end">
              <ButtonWithMenu modern iconOnly={true} menuBody={getMenuBody()} />
            </div>
          </div>
        </div>
        <div className="flex-1 flex flex-col">
          <div className="text-base font-semibold text-slate-800">{resource.name}</div>
          <div className="max-h-[35px]">
            <Tooltip enterTouchDelay={0} title={resource.description}>
              <div className="text-xs font-medium text-slate-500 line-clamp-2">{resource.description}</div>
            </Tooltip>
          </div>
        </div>
        <Button className={`${classes.viewButton} !normal-case !text-slate-700 !font-semibold`} onClick={() => {
          handlePreviewOpen();
          Analytics.track('Preview resource button clicked');
        }}>
          {intl.formatMessage(messages.preview)}
        </Button>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {modalBody}
      </Modal>
      <Modal
        open={previewOpen}
        onClose={handlePreviewClose}
        aria-labelledby="preview-modal-title"
        aria-describedby="preview-modal-description"
      >
        <div className={paperClasses} style={{ maxWidth: '90vw', width: '800px', height: '80vh', padding: 0 }}>
          <div className="p-4 border-b border-solid border-slate-200 bg-slate-100/50 flex justify-between items-center">
            <h2 className="m-0 text-xl font-bold text-slate-800">Preview: {resource.name}</h2>
            <Button
              onClick={handlePreviewClose}
              className="!bg-white hover:!bg-slate-50 !text-slate-700 !font-semibold !px-5 !py-2.5 !rounded-xl !border !border-solid !border-slate-300 !normal-case">
              Close
            </Button>
          </div>
          <iframe
            src={`${linkUrl}?preview=true`}
            style={{ width: '100%', height: 'calc(100% - 60px)', border: 'none' }}
            title={`Preview of ${resource.name}`}
          />
        </div>
      </Modal>
    </>
  );
};

export default ResourceListItem;
